import { ComboStepConfig } from '../shared/combo-types'

export const AMOR_MERECIMIENTO_NAME = 'Amor y Merecimiento'

export const AMOR_MERECIMIENTO_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de amor y merecimiento (amor para solteros → amor propio y merecimiento → conexión con tu yo futuro).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo la lectura amorosa para solteros, el amor propio y merecimiento y el yo futuro en el amor forman un mismo camino de apertura al amor consciente.',
}

export const AMOR_MERECIMIENTO_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-amor-solteros',
        title: 'Tirada del Amor — Amor para Solteros',
        shortTitle: 'Amor para Solteros',
        fixedLoveTipo: '4',
        loveTipoLabel: 'Amor para Solteros',
    },
    {
        step: 2,
        type: 'combo-amor-propio',
        title: 'Tirada de Amor Propio y Merecimiento',
        shortTitle: 'Amor Propio y Merecimiento',
    },
    {
        step: 3,
        type: 'combo-amor-yo-futuro',
        title: 'Tirada de Conexión con tu Yo Futuro',
        shortTitle: 'Conexión con tu Yo Futuro',
    },
]

export const AMOR_MERECIMIENTO_TOTAL_STEPS = AMOR_MERECIMIENTO_STEPS.length
